import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CButton } from '@coreui/react';
import Parametros from './parametros';
import '../../scss/styles-infra.scss';

/** Parâmetros de um cliente já criado. */
const ConfigDiff = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();

    return (
        <div className="infra-container infra-container-rolavel">
            <div className="infra-cabecalho">
                <div>
                    <h4 className="infra-titulo">Configurações</h4>
                    <div className="infra-subtitulo">
                        <span>O que os passos usam quando rodam.</span>
                    </div>
                </div>
                <div className="infra-acoes-topo">
                    <CButton color="secondary" variant="outline"
                        onClick={() => history.push('/infra/pipeline/' + id)}>
                        Voltar ao fluxo
                    </CButton>
                </div>
            </div>

            <Parametros pipelineId={id} />
        </div>
    );
};

export default ConfigDiff;
